export default {
      id: "check-mark-usage",
      viewBox: "0 0 352.62 352.62",
      url: __webpack_public_path__ + "app/svg/sprite.svg#check-mark",
      toString: function () {
        return this.url;
      }
    }